module.exports = __webpack_public_path__ + "img/shequ-5.5a596c33.png";